import EventManagerError from './event-manager-error';
import { ERROR_TYPES } from './event-manager-error.constants';

export { ERROR_TYPES };

export default EventManagerError;
